@charset "UTF-8";
/* ==========================================================================
   Design System
   Advanced Typography
   ========================================================================== */
/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
.m-pull-quote__body {
  /* stylelint-enable */
  margin-bottom: 0.6818181818em;
  font-size: 1.375em;
  font-weight: normal;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
  color: var(--black);
}
@media only all and (max-width: 37.5em) {
  .m-pull-quote__body {
    /* stylelint-enable */
    margin-bottom: 0.8333333333em;
    font-size: 1.125em;
    font-weight: 500;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
}
.m-pull-quote__citation {
  /* stylelint-enable */
  margin-bottom: 1.0714285714em;
  font-size: 0.875em;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.25;
  text-transform: uppercase;
  color: var(--gray);
}
.m-pull-quote__citation::before {
  content: "—";
}